import { render, staticRenderFns } from "./MaydayWebProductViewer.vue?vue&type=template&id=2312d8be&scoped=true&"
import script from "./MaydayWebProductViewer.vue?vue&type=script&lang=js&"
export * from "./MaydayWebProductViewer.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebProductViewer.vue?vue&type=style&index=0&id=2312d8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312d8be",
  null
  
)

export default component.exports